import { request } from "./common";

const API_URL = `${process.env.API_URL || "/api"}`;

/**
 * Helper method to get payment iframe
 * @param {*} data
 * @param {*} options
 * @returns {Iframe}
 */
export function getPaymentIframe(data, options) {
  return request(`https://secure.cardcom.solutions/Interface/LowProfile.aspx`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data,
    ...options,
  });
}
